declare global {
  interface Window {
    webkit?: any;
  }
}

export const isPushAvailable = (): boolean => {
  return (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers['push-permission-request'] &&
    window.webkit.messageHandlers['push-permission-state'] &&
    window.webkit.messageHandlers['push-token']
  );
};

// returns the push token or an empty string if the user denies push notifications
export const enablePushNotifications = async (): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (isPushAvailable()) {
      const onPushToken = (event: any) => {
        if (event && event.detail) {
          window.removeEventListener('push-token', onPushToken);
          resolve(event.detail);
        }
      };

      const onPushPermissionRequest = (event: any) => {
        if (event && event.detail) {
          switch (event.detail) {
            case 'granted':
              window.webkit.messageHandlers['push-token'].postMessage('push-token');
              break;
            default:
              reject('Push notifications not authorized');
              break;
          }
        }
      };

      window.addEventListener('push-token', onPushToken);
      window.addEventListener('push-permission-request', onPushPermissionRequest);

      window.webkit.messageHandlers['push-permission-request'].postMessage('push-permission-request');
    } else {
      reject('iOS push capability not available');
    }
  });
};

